/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Timeline from "@material-ui/icons/Timeline";
import Code from "@material-ui/icons/Code";
import Group from "@material-ui/icons/Group";
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
import Phone from "@material-ui/icons/Phone";
// import LockOutline from "@material-ui/icons/LockOutline";
import Check from "@material-ui/icons/Check";

// core components
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import FileUpload from "components/CustomUpload/FileUpload";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import NavPills from "components/NavPills/NavPills.jsx";

import registerPageStyle from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";

import firebase from 'helpers/firebase';
import FirebaseUIAuth from "react-firebaseui-localized";

// Configure FirebaseUI.
const personalAccountConfig = {
  signInFlow: "popup",
  signInSuccessUrl: "/",
  signInOptions: [
    {
      provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
      recaptchaParameters: {
        type: 'image', // 'audio'
        size: 'invisible', // 'invisible' or 'compact'
        badge: 'bottomleft' //' bottomright' or 'inline' applies to invisible.
      },
      defaultCountry: 'KR',
    },
    firebase.auth.EmailAuthProvider.PROVIDER_ID
  ],
  tosUrl: "/auth/terms",
  privacyPolicyUrl: "/auth/privacy"
};

const styles = {
  ...registerPageStyle,
}

class RegisterPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: []
    };
    this.handleToggle = this.handleToggle.bind(this);
  }
  handleToggle(value) {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({
      checked: newChecked
    });
  }
  renderSignUpPersonal = () => {
    // const { classes } = this.props;

    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={6}>
          <InfoArea
            title="엔브레인 프로그램"
            description="엔브레인플랫폼에서는 개인회원을 위해 엔브레인프로그램/정신건강테스트를 제공하고있습니다"
            icon={Timeline}
            iconColor="primary"
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <FirebaseUIAuth
            lang="ko"
            config={personalAccountConfig}
            auth={firebase.auth()}
            firebase={firebase}
          />
        </GridItem>
      </GridContainer>
    )
  }

  onFileLoaded = (file) => {
    console.log(file);
    this.setState({ file });
  }

  renderSignUpOrganization = () => {
    const { classes } = this.props;

    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={5}>
          <InfoArea
            title="인지지원서비스 사례관리"
            description="인지지원서비스는 치매환자를 건강하고 안전하게 심리적인 편안함을 유지하면서 삶의 질을 최대한 유지하며 살수 있도록 지원하기 위한 서비스입니다."
            icon={Code}
            iconColor="rose"
          />
          <InfoArea
            title="협회/복지관 관리, 보고서 양식"
            description="협회 소속 복지관의 보고 서식 및 데이터 분석 리포팅 기능"
            icon={Group}
            iconColor="info"
          />
        </GridItem>
        <GridItem xs={12} sm={8} md={5}>
          <form className={classes.form}>
            <CustomInput
              formControlProps={{
                fullWidth: true,
                className: classes.customFormControlClasses
              }}
              inputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    className={classes.inputAdornment}
                  >
                    <Face className={classes.inputAdornmentIcon} />
                  </InputAdornment>
                ),
                placeholder: "기관명"
              }}
            />
            <CustomInput
              formControlProps={{
                fullWidth: true,
                className: classes.customFormControlClasses
              }}
              inputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    className={classes.inputAdornment}
                  >
                    <Face className={classes.inputAdornmentIcon} />
                  </InputAdornment>
                ),
                placeholder: "이름"
              }}
            />
            <CustomInput
              formControlProps={{
                fullWidth: true,
                className: classes.customFormControlClasses
              }}
              inputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    className={classes.inputAdornment}
                  >
                    <Phone className={classes.inputAdornmentIcon} />
                  </InputAdornment>
                ),
                placeholder: "전화번호"
              }}
            />
            <CustomInput
              formControlProps={{
                fullWidth: true,
                className: classes.customFormControlClasses
              }}
              inputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    className={classes.inputAdornment}
                  >
                    <Email className={classes.inputAdornmentIcon} />
                  </InputAdornment>
                ),
                placeholder: "이메일"
              }}
            />
            <CustomInput
              formControlProps={{
                fullWidth: true,
                className: classes.customFormControlClasses
              }}
              inputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    className={classes.inputAdornment}
                  >
                    <Icon className={classes.inputAdornmentIcon}>
                      lock_outline
                    </Icon>
                  </InputAdornment>
                ),
                placeholder: "비밀번호",
                type: "password"
              }}
            />
            <FileUpload onFileLoaded={this.onFileLoaded} buttonTitle="사업자등록증 첨부하기" />

            <FormControlLabel
              classes={{
                root: classes.checkboxLabelControl,
                label: classes.checkboxLabel
              }}
              control={
                <Checkbox
                  tabIndex={-1}
                  onClick={() => this.handleToggle(1)}
                  checkedIcon={
                    <Check className={classes.checkedIcon} />
                  }
                  icon={<Check className={classes.uncheckedIcon} />}
                  classes={{
                    checked: classes.checked,
                    root: classes.checkRoot
                  }}
                />
              }
              label={
                <span>
                  체크박스를 체크함으로{" "}<a href="#pablo">이용약관과 개인정보 보호정책에</a>{" "}동의합니다.
                </span>
              }
            />
            <div className={classes.center}>
              <Button round color="primary">
                시작합니다
              </Button>
            </div>
          </form>
        </GridItem>
      </GridContainer >

    )
  }

  renderSignUpAssociation = () => {
    const { classes } = this.props;

    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={5}>
          <InfoArea
            title="협회/복지관 관리, 보고서 양식"
            description="협회 소속 복지관의 보고 서식 및 데이터 분석 리포팅 기능"
            icon={Group}
            iconColor="info"
          />
        </GridItem>
        <GridItem xs={12} sm={8} md={5}>
          <form className={classes.form}>
            <CustomInput
              formControlProps={{
                fullWidth: true,
                className: classes.customFormControlClasses
              }}
              inputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    className={classes.inputAdornment}
                  >
                    <Face className={classes.inputAdornmentIcon} />
                  </InputAdornment>
                ),
                placeholder: "성함 혹은 기관명"
              }}
            />
            <CustomInput
              formControlProps={{
                fullWidth: true,
                className: classes.customFormControlClasses
              }}
              inputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    className={classes.inputAdornment}
                  >
                    <Email className={classes.inputAdornmentIcon} />
                  </InputAdornment>
                ),
                placeholder: "이메일"
              }}
            />
            <CustomInput
              formControlProps={{
                fullWidth: true,
                className: classes.customFormControlClasses
              }}
              inputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    className={classes.inputAdornment}
                  >
                    <Icon className={classes.inputAdornmentIcon}>
                      lock_outline
                    </Icon>
                  </InputAdornment>
                ),
                placeholder: "비밀번호"
              }}
            />
            <FormControlLabel
              classes={{
                root: classes.checkboxLabelControl,
                label: classes.checkboxLabel
              }}
              control={
                <Checkbox
                  tabIndex={-1}
                  onClick={() => this.handleToggle(1)}
                  checkedIcon={
                    <Check className={classes.checkedIcon} />
                  }
                  icon={<Check className={classes.uncheckedIcon} />}
                  classes={{
                    checked: classes.checked,
                    root: classes.checkRoot
                  }}
                />
              }
              label={
                <span>
                  체크박스를 체크함으로{" "}<a href="#pablo">이용약관과 개인정보 보호정책에</a>{" "}동의합니다.
                </span>
              }
            />
            <div className={classes.center}>
              <Button round color="primary">
                시작합니다
              </Button>
            </div>
          </form>
        </GridItem>
      </GridContainer>

    )
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader>
                <h4 className={classes.cardTitle}>
                  회원 가입하기
            </h4>
              </CardHeader>
              <CardBody>
                <NavPills
                  color="info"
                  alignCenter
                  tabs={[
                    {
                      tabButton: "개인회원",
                      tabContent: this.renderSignUpPersonal()
                    },
                    {
                      tabButton: "기관회원",
                      tabContent: this.renderSignUpOrganization()
                    }
                  ]}
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

RegisterPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(RegisterPage);